import React from 'react'
import useWpJson from '../Hooks/useWpJson'
import Loader from '../Components/Loader'
export default function FooterText () {
  const footer = useWpJson('footer-text')

  return footer ? (
    <div className='text-header5' dangerouslySetInnerHTML={{ __html: footer }} />
  ) : (
    <Loader />
  )
}
